export const environment = {
  baseUrl: 'https://be-dev.westeurope.cloudapp.azure.com',
  signIn: '/identity-api/connect/token',
  signUp: '/identity-api/api/account/signup',
  stoves: '/core-api/api/stoves',
  exampleEmail: 'admin@example.com',
  examplePassword: 'Admin123!',
  resendEmail: '/identity-api/api/account/resend-confirmation-email',
  statistics: '/core-api/api/statistics',
  stoveStatistics: '/core-api/api/statistics/stoves/',
  updateUser: '/identity-api/api/account/update-user',
  users: '/core-api/api/users',
  forgotPassword: '/identity-api/api/account/forgot-password',
  updateForgotPassword: '/identity-api/api/account/update-forgotten-password',
  me: '/identity-api/api/account/me',
  firmwares: '/core-api/api/firmwares',
  stovesFirmware: '/core-api/api/stoves/firmware',
  testResults: '/core-api/api/TestResults',
};
